export const shoeSizeData = {
  women: [
    { footLength: 220, cn: 34, jp: 22.0, eu: 35, us: 4.5, uk: 2.5 },
    { footLength: 225, cn: 35, jp: 22.5, eu: 35.5, us: 5, uk: 3 },
    { footLength: 230, cn: 36, jp: 23.0, eu: 36, us: 5.5, uk: 3.5 },
    { footLength: 235, cn: 37, jp: 23.5, eu: 37, us: 6, uk: 4 },
    { footLength: 240, cn: 38, jp: 24.0, eu: 38, us: 6.5, uk: 4.5 },
    { footLength: 245, cn: 39, jp: 24.5, eu: 38.5, us: 7, uk: 5 },
    { footLength: 250, cn: 40, jp: 25.0, eu: 39, us: 7.5, uk: 5.5 },
    { footLength: 255, cn: 41, jp: 25.5, eu: 40, us: 8, uk: 6 },
    { footLength: 260, cn: 42, jp: 26.0, eu: 41, us: 9, uk: 7 },
  ],
  men: [
    { footLength: 245, cn: 39, jp: 24.5, eu: 39, us: 6.5, uk: 5.5 },
    { footLength: 250, cn: 40, jp: 25.0, eu: 40, us: 7, uk: 6 },
    { footLength: 255, cn: 41, jp: 25.5, eu: 40.5, us: 7.5, uk: 6.5 },
    { footLength: 260, cn: 42, jp: 26.0, eu: 41, us: 8, uk: 7 },
    { footLength: 265, cn: 43, jp: 26.5, eu: 42, us: 8.5, uk: 7.5 },
    { footLength: 270, cn: 44, jp: 27.0, eu: 42.5, us: 9, uk: 8 },
    { footLength: 275, cn: 45, jp: 27.5, eu: 43, us: 9.5, uk: 8.5 },
    { footLength: 280, cn: 46, jp: 28.0, eu: 44, us: 10, uk: 9 },
    { footLength: 285, cn: 47, jp: 28.5, eu: 44.5, us: 10.5, uk: 9.5 },
    { footLength: 290, cn: 48, jp: 29.0, eu: 45, us: 11, uk: 10 },
  ],
};

export const clothingSizeData = {
  womenTop: [
    { asian: 'S', eu: 'XS', us: '2', bust: '80-84', waist: '62-66' },
    { asian: 'M', eu: 'S', us: '4', bust: '84-88', waist: '66-70' },
    { asian: 'L', eu: 'M', us: '6', bust: '88-92', waist: '70-74' },
    { asian: 'XL', eu: 'L', us: '8', bust: '92-96', waist: '74-78' },
    { asian: 'XXL', eu: 'XL', us: '10', bust: '96-100', waist: '78-82' },
  ],
  menTop: [
    { asian: 'S', eu: 'XS', us: 'XS', bust: '88-92', shoulder: '42-44' },
    { asian: 'M', eu: 'S', us: 'S', bust: '92-96', shoulder: '44-46' },
    { asian: 'L', eu: 'M', us: 'M', bust: '96-100', shoulder: '46-48' },
    { asian: 'XL', eu: 'L', us: 'L', bust: '100-104', shoulder: '48-50' },
    { asian: 'XXL', eu: 'XL', us: 'XL', bust: '104-108', shoulder: '50-52' },
  ],
  pants: [
    { asian: 28, eu: 42, us: 28, waist: '71-73', hip: '89-91' },
    { asian: 29, eu: 44, us: 29, waist: '73-76', hip: '91-93' },
    { asian: 30, eu: 46, us: 30, waist: '76-79', hip: '93-95' },
    { asian: 31, eu: 48, us: 31, waist: '79-81', hip: '95-97' },
    { asian: 32, eu: 50, us: 32, waist: '81-84', hip: '97-99' },
    { asian: 33, eu: 52, us: 33, waist: '84-86', hip: '99-101' },
    { asian: 34, eu: 54, us: 34, waist: '86-89', hip: '101-103' },
  ],
};

export const kidsSizeData = {
  shoes: [
    { footLength: 110, cn: 18, eu: 19, us: 3.5, uk: 2.5, age: '0-1岁' },
    { footLength: 120, cn: 19, eu: 20, us: 4.5, uk: 3.5, age: '1-2岁' },
    { footLength: 130, cn: 21, eu: 22, us: 5.5, uk: 4.5, age: '2-3岁' },
    { footLength: 140, cn: 22, eu: 23, us: 6.5, uk: 5.5, age: '3-4岁' },
    { footLength: 150, cn: 24, eu: 25, us: 8, uk: 7, age: '4-5岁' },
    { footLength: 160, cn: 26, eu: 27, us: 9.5, uk: 8.5, age: '5-6岁' },
    { footLength: 170, cn: 28, eu: 29, us: 11, uk: 10, age: '6-7岁' },
    { footLength: 180, cn: 30, eu: 31, us: 12.5, uk: 11.5, age: '7-8岁' },
    { footLength: 190, cn: 31, eu: 32, us: 13.5, uk: 12.5, age: '8-9岁' },
    { footLength: 200, cn: 33, eu: 34, us: 1.5, uk: 13.5, age: '9-10岁' },
    { footLength: 210, cn: 34, eu: 35, us: 2.5, uk: 1, age: '10-11岁' },
    { footLength: 220, cn: 35, eu: 36, us: 3.5, uk: 2, age: '11-12岁' },
  ],
  clothing: [
    { height: '50-60', asian: '60', eu: '56', us: '0-3M', age: '新生儿' },
    { height: '60-70', asian: '70', eu: '62', us: '3-6M', age: '3-6月' },
    { height: '70-80', asian: '80', eu: '74', us: '6-12M', age: '6-12月' },
    { height: '80-90', asian: '90', eu: '86', us: '12-18M', age: '1-2岁' },
    { height: '90-100', asian: '100', eu: '98', us: '2T', age: '2-3岁' },
    { height: '100-110', asian: '110', eu: '104', us: '3T', age: '3-4岁' },
    { height: '110-120', asian: '120', eu: '116', us: '4T', age: '4-5岁' },
    { height: '120-130', asian: '130', eu: '128', us: '5', age: '5-6岁' },
    { height: '130-140', asian: '140', eu: '140', us: '7', age: '7-8岁' },
    { height: '140-150', asian: '150', eu: '152', us: '10', age: '9-10岁' },
    { height: '150-160', asian: '160', eu: '164', us: '14', age: '11-12岁' },
  ],
};

export const faqs = [
  {
    question: '什么是亚洲五码？',
    answer: '亚洲五码是亚洲地区通用的尺码标准体系，主要包括中国码（CN）、日本码（JP）、韩国码（KR）等。它并非一个官方标准名称，而是消费者对亚洲主流尺码的通俗称呼。亚洲五码以脚长或身体尺寸的毫米/厘米数为基准，与欧码、美码、英码有固定的换算关系。'
  },
  {
    question: '亚洲五码和欧码怎么换算？',
    answer: '鞋码换算公式为：欧码 = (中国码 ÷ 5) × 2 + 1。例如中国码240（脚长24.0cm）对应的欧码约为38-39码。服装尺码方面，亚洲码普遍比欧码小1-2个号，亚洲L码大致对应欧码M码。建议在购买前查看具体品牌的尺码表以获得最准确的对照。'
  },
  {
    question: '亚洲五码和美码怎么换算？',
    answer: '男鞋：美码 = (中国码 - 220) ÷ 5 × 3 + 5；女鞋：美码 = (中国码 - 220) ÷ 5 × 3 + 4.5。举例来说，中国码260的男鞋对应美码约8码，中国码240的女鞋对应美码约6.5码。服装方面，亚洲码普遍比美码小1.5-2个号。'
  },
  {
    question: '为什么亚洲尺码普遍偏小？',
    answer: '亚洲人的平均体型相比欧美人群偏瘦小，因此亚洲品牌的版型设计更加修身。同样标注为L码的衣服，亚洲品牌的胸围、肩宽等数据通常会比欧美品牌小3-5cm。这是基于目标消费群体体型差异的设计选择，并非品质问题。'
  },
  {
    question: '网购时如何确保选对尺码？',
    answer: '首先准确测量自己的尺寸（脚长、胸围、腰围等）；其次查看目标品牌的具体尺码表；第三阅读买家评价中关于尺码偏大/偏小的反馈；第四了解不同品类的选码规律（如运动鞋选大半码、皮鞋合脚即可）；最后，不确定时可同时购买两个相邻尺码进行试穿。'
  },
  {
    question: '亚洲五码对照表准吗？不同品牌有差异吗？',
    answer: '亚洲五码对照表提供的是通用换算关系，可以作为重要参考。但不同品牌确实存在尺码差异：例如日本品牌普遍偏小半码，韩国品牌剪裁偏修身，中国本土品牌相对标准。建议将对照表作为基准，再结合具体品牌的尺码指南进行微调。'
  },
  {
    question: '儿童尺码怎么选？多久换一次？',
    answer: '儿童鞋内长应比脚长大0.5-1cm，给孩子脚趾留出活动空间。建议每3-4个月重新测量一次脚长，因为儿童脚部发育非常快。童装可根据身高选择，亚洲童装通常标注身高范围（如110码适合身高105-115cm的儿童）。避免买过大的鞋子"将就穿"，可能影响孩子脚部正常发育。'
  },
  {
    question: '亚洲五码、中国码、日本码之间有什么区别？',
    answer: '中国码和日本码都以厘米/毫米为单位，但标注方式不同：中国码240表示脚长240mm，日本码24.0表示脚长24.0cm，数值上是10倍关系。韩国码范围在220-300之间，男女通用。香港地区多采用欧洲码体系。虽然叫法不同，但本质上都是以脚长为基准的尺寸体系。'
  }
];